import { ChatError, ChatErrorCode } from '../services/errorHandler'
import { VALIDATION_CONSTANTS } from '../constants/validation'

export function isValidMessageContent(content: string): boolean {
  return (
    content.trim().length >= VALIDATION_CONSTANTS.MESSAGE.MIN_LENGTH
    && content.length <= VALIDATION_CONSTANTS.MESSAGE.MAX_LENGTH
  )
}

export function validateMessageContent(content: string): void {
  if (!content.trim()) {
    throw new ChatError(
      'Сообщение не может быть пустым',
      ChatErrorCode.INVALID_INPUT,
    )
  }

  if (content.length > VALIDATION_CONSTANTS.MESSAGE.MAX_LENGTH) {
    throw new ChatError(
      `Сообщение не может быть длиннее ${VALIDATION_CONSTANTS.MESSAGE.MAX_LENGTH} символов`,
      ChatErrorCode.INVALID_INPUT,
    )
  }
}

export function isValidChatId(id: unknown): id is number | string {
  return (
    typeof id === 'number'
    || (typeof id === 'string' && id.trim().length > 0)
  )
}

export function validateChatId(id: unknown): asserts id is number | string {
  if (!isValidChatId(id)) {
    throw new ChatError(
      'ID чата должен быть числом или непустой строкой',
      ChatErrorCode.INVALID_INPUT,
    )
  }
}

/** Идентификаторы участников для инвайта/кика в Matrix */
export function filterValidUserIds(userIds: Array<string | number>): string[] {
  return userIds
    .map(id => String(id).trim())
    .filter(Boolean)
}
